// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import style from './Banner.scss';

import type { Element } from 'react';

export type BannerColor = 'blue' | 'grey' | 'orange' | 'white';

type Props = {
  color: BannerColor;
  translatedId?: string;
  titleElement?: Element<any>;
  rightElement?: Element<any>;
};

export default class Banner extends Component<Props, void> {
  static defaultProps = {
    color: 'blue',
  };

  render() {
    const { translatedId, color, titleElement, rightElement } = this.props;
    const title = translatedId ?
      <FormattedMessage id={translatedId}>{
        txt => <h1>{txt}</h1>
      }</FormattedMessage>
      : titleElement;
    return (
      <header key="header"
              className={classNames(style.bannerHeader, style[color])}>
        <section className={style.bannerContent}>
          {title}
          <article className={style.rightContent}>
            {rightElement}
          </article>
        </section>
      </header>
    );
  }
}

Banner.propTypes = {
  color: PropTypes.string,
  translatedId: PropTypes.string,
  titleElement: PropTypes.element,
  rightElement: PropTypes.element,
};



// WEBPACK FOOTER //
// ./src/elements/Banner/Banner.jsx